import { calcTaxAmt } from './taxAmtCalc_function';

export const createTaxAmtExpense = (expenseTable, assetTable, startTaxDate) => {
      // remove current tax expense (set current payroll tax expense item to 0 months)
      let taxIndx = 99;
      let newExpenseTable = JSON.parse(JSON.stringify(expenseTable));
      let currentTaxAmt = 0;
      taxIndx = newExpenseTable.findIndex(elem => elem.expItem === "Payroll taxes" &&
            elem.expNbrMonths === "-1");
      if (taxIndx !== -1){
            if (newExpenseTable[taxIndx].expStartDate <= startTaxDate){
                  currentTaxAmt = newExpenseTable[taxIndx].expAmount; 
            }
      }
        
      let newTaxAmt = calcTaxAmt(assetTable);
      let taxAmtChgd = false;
      let oldTaxAmtExpense = {};
      if (+currentTaxAmt !== +newTaxAmt){
            taxAmtChgd = true;
            if (taxIndx !== -1){
                  oldTaxAmtExpense = newExpenseTable[taxIndx];
                  newExpenseTable[taxIndx].expNbrMonths = 0;
            }
            const taxAmtExpense = {expItem: "Payroll taxes", expDesc: "Federal, FICA (Social Security)", 
                  expStartDate: startTaxDate, expAmount: newTaxAmt, expNbrMonths: "-1", 
                  chargeCreditCard: false};
            newExpenseTable.push(taxAmtExpense);
      }
      const expenseTaxObj = {expenseTable: newExpenseTable, taxAmtChgd: taxAmtChgd, 
            oldTaxExpense: oldTaxAmtExpense, newTaxAmt: newTaxAmt}; 
                
   return expenseTaxObj;
   
}
